import React from "react";
import roundBankbox from "../../../assets/round bankbox.png";
import DashboardLayout from "../../../layout/dashboard/DashboardLayout";
import TitleTextBox from "../../../fragments/TitleTextBox";
import ContainerWrapper from "../../../fragments/ContainerWrapper";
import { RavenButton, RavenNumberFormat } from "@ravenpay/raven-bank-ui";
import "../../../styles/dashboard/terminals/RequestTerminalDetails.css";
import { useLocation, useNavigate } from "react-router-dom";
import { formatCamelCase, getFormattedTodayDate } from "../../../utils/helpers";
import { requestTerminal } from "../../../redux/insight";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/types";
import { formatNumWithCommaNairaSymbol } from "../../../helper";
import { RouteLinks } from "../../../routes/RouteLinks";
const RequestTerminalOutputIndex = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const requestObject = location.state;
  const { loading } = useSelector((state: RootState) => state.insights);
  const handleRequestTerminal = async () => {
    const obj = {
      quantity: requestObject.quantity,
      delivery_state: requestObject?.state,
      delivery_address: requestObject?.streetAddress,
      delivery_option: requestObject?.deliveryMethod,
      delivery_lga: requestObject?.city,
      pickup_location_id: requestObject?.deliveryPickupId,
      // terminal_price:requestObject.pricePerOne
    };
    const data = await dispatch(requestTerminal(obj as any) as any);
    console.log("this is dataaaaaa", data);

    if (data?.payload?.status === "success") {
     navigate(RouteLinks.AllRequested_Terminal)
    }
    else{
      navigate(RouteLinks.Request_Terminal)
    }
  };
  const todaysDate = getFormattedTodayDate();

  // const requestObject = [
  //     {
  //       name: "Quantity",
  //       value: 1,
  //     },
  //     {
  //       name: "Delivery Method",
  //       value: "Pick up",
  //     },
  //     {
  //       name: "Bank Name",
  //       value: "First Bank",
  //     },
  //     {
  //       name: "Bank City",
  //       value: "Surulere",
  //     },
  //     {
  //       name: "Bank Address",
  //       value: "24 Agege",
  //     },
  //     {
  //       name: "Price Per One",
  //       value: "20,000",
  //     },
  //   ];
  return (
    <>
      <DashboardLayout>
        <TitleTextBox
          text="Power your business with a strong toolkit designed for growth"
          title="Request a Terminal"
          back
          onBack={() => {
            navigate(-1);
          }}
        ></TitleTextBox>
        <ContainerWrapper
          width={`100%`}
          className="container-wrapper-cont"
          dontShowHeader
        >
          <div className="request-terminal-detail-general-div-container">
            <div className="bank-box-image-holder">
              <figure>
                <img src={roundBankbox} alt="bank-box" />
              </figure>
            </div>
            <div className="request-terminal-detail-general-div">
              <div className="request-terminal-detail-general-div-headers">
                <p className="terminal-amount-box">
                  {RavenNumberFormat(
                    requestObject?.pricePerOne * requestObject?.quantity
                  )}
                </p>
                <p className="pick-up-datbox">{todaysDate}</p>
              </div>
              <div className="request-terminal-detail-general-div-body">
                {Object.entries(requestObject).map(([key, value], index) => (
                  <div className="request-details-card">
                    {key !== "deliveryPickupId" && (
                      <>
                        <p className="request-detail-name">
                          {formatCamelCase(key)}
                        </p>
                        <p className="request-detail-value">
                          {key === "state" || key === "city"
                            ? (value as { value: string }).value
                            : key === "pricePerOne"? formatNumWithCommaNairaSymbol(value as number)
                            : key === "deliveryMethod" && value === "home_delivery"? value = "Home Delivery"
                            : key === "deliveryMethod" && value === "pickup"? value = "Pick Up"
                            : String(value)}
                        </p>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <RavenButton
              color="deep-green-light"
              label="Request Terminal"
              className="reques-raven-submit-button"
              onClick={handleRequestTerminal}
              loading={loading}
            />
          </div>
        </ContainerWrapper>
      </DashboardLayout>
    </>
  );
};

export default RequestTerminalOutputIndex;
